export default "__VITE_ASSET__ByiSggPf__"